import { useState, type ReactNode } from 'react';
import * as React from 'react';
import { Modal, Paragraph } from '@hungryroot/ramen';
import { segmentAnalytics as analytics } from '@hungryroot/segment';
import { EditBlock } from '../EditBlock/EditBlock';
import { RadioGroup, Radio } from '../RadioGroup/RadioGroup';
import styles from './Occasion.module.css';

interface OccasionProps {
  testid?: string;
  heading: string;
  description: string;
  onDismiss?: () => void;
  onSubmit?: (value: string) => void;
  isSubmitting?: boolean;
  confirmButtonText: string;
  initialValue?: string | number;
  title: string;
  icon?: React.ReactNode;
  options: { label: string; value: string; illustration?: ReactNode }[];
  className?: string;
  editDisabled?: boolean;
  containerName: string;
  containerId: number;
  subtitle?: string;
}

export function Occasion(props: OccasionProps) {
  const {
    testid,
    heading,
    description,
    onDismiss,
    onSubmit,
    isSubmitting,
    confirmButtonText,
    initialValue = '',
    title,
    icon,
    options,
    className,
    editDisabled,
    containerName,
    containerId,
    subtitle,
  } = props;

  const [value, setValue] = useState(initialValue.toString());

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnDismiss = () => {
    setIsModalOpen(false);
    onDismiss?.();
  };

  return (
    <>
      <EditBlock
        className={className}
        icon={icon}
        heading={heading}
        description={description}
        onClick={() => setIsModalOpen(true)}
        editDisabled={editDisabled}
      />
      {isModalOpen && (
        <Modal
          showXButton
          testid={testid}
          isSubmitting={isSubmitting}
          onDismiss={handleOnDismiss}
          onActionClick={() => {
            analytics.track('Container Tier Dropdown', {
              tiered_tier_type: Number(value),
              container_name: containerName,
              container_id: containerId,
            });
            onSubmit?.(value);
            setIsModalOpen(false);
          }}
          heading={title}
          confirmButtonText={confirmButtonText}
          ariaLabel={title}
          isOpen={isModalOpen}
          body={
            <>
              {subtitle && (
                <Paragraph className={styles.subtitle}>{subtitle}</Paragraph>
              )}
              <RadioGroup label={title} onChange={setValue} value={value}>
                {options.map(({ label, value, illustration }) => {
                  return (
                    <Radio
                      key={value}
                      testid={label}
                      label={label}
                      value={value}
                      illustration={illustration}
                    />
                  );
                })}
              </RadioGroup>
            </>
          }
        ></Modal>
      )}
    </>
  );
}
